import { useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import { toast } from "sonner";
import { BookOpen, ArrowLeft } from "lucide-react";
import { useAuth } from "@/lib/auth";

export default function AdminLoginPage() {
  const { login } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [submitting, setSubmitting] = useState(false);

  const onSubmit = async (e) => {
    e.preventDefault();
    setSubmitting(true);
    try {
      await login(email.trim(), password);
      toast.success("Welcome back");
      navigate("/admin");
    } catch (err) {
      const detail = err?.response?.data?.detail;
      toast.error(typeof detail === "string" ? detail : "Login failed.");
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <div className="min-h-screen topo-bg flex flex-col" data-testid="admin-login-page">
      <div className="max-w-7xl w-full mx-auto px-4 sm:px-6 lg:px-8 pt-8">
        <Link to="/" className="inline-flex items-center gap-2 text-sm text-ink-muted hover:text-brand">
          <ArrowLeft className="w-4 h-4" /> Back to journal
        </Link>
      </div>

      <div className="flex-1 flex items-center justify-center px-4 py-16">
        <div className="w-full max-w-md bg-white rounded-3xl border border-ink/5 shadow-[0_30px_80px_-40px_rgba(30,77,58,0.35)] p-8 sm:p-10">
          <div className="flex items-center gap-3 mb-7">
            <span className="w-11 h-11 rounded-xl bg-brand text-white flex items-center justify-center">
              <BookOpen className="w-5 h-5" />
            </span>
            <div>
              <div className="font-serif text-xl text-ink">Editor sign in</div>
              <div className="text-xs text-ink-subtle">SummaryMaps Journal</div>
            </div>
          </div>

          <form onSubmit={onSubmit} className="space-y-4" data-testid="admin-login-form">
            <div>
              <label htmlFor="email" className="block text-xs uppercase tracking-[0.15em] text-ink-subtle mb-2">Email</label>
              <input
                id="email"
                type="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                required
                className="w-full px-4 py-3 rounded-xl bg-cream border border-ink/10 focus:border-brand focus:ring-2 focus:ring-brand/20 outline-none transition"
                placeholder="you@summarymaps.com"
                data-testid="admin-email-input"
              />
            </div>
            <div>
              <label htmlFor="password" className="block text-xs uppercase tracking-[0.15em] text-ink-subtle mb-2">Password</label>
              <input
                id="password"
                type="password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                required
                className="w-full px-4 py-3 rounded-xl bg-cream border border-ink/10 focus:border-brand focus:ring-2 focus:ring-brand/20 outline-none transition"
                placeholder="••••••••"
                data-testid="admin-password-input"
              />
            </div>

            <button
              type="submit"
              disabled={submitting}
              className="w-full mt-2 inline-flex items-center justify-center gap-2 bg-brand text-white font-medium rounded-full px-6 py-3.5 hover:bg-brand-hover transition-colors disabled:opacity-60"
              data-testid="admin-login-btn"
            >
              {submitting ? "Signing in…" : "Sign in"}
            </button>
          </form>
        </div>
      </div>
    </div>
  );
}
